module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t(_vm.title),
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "arrow": _vm.document.length > 1 ? 'hover' : 'never',
      "height": _vm.height + 'px'
    },
    on: {
      "change": _vm.doResize
    }
  }, _vm._l((_vm.document), function(doc, index) {
    return _c('el-carousel-item', {
      key: index,
      ref: "caroItem",
      refInFor: true
    }, [_c('h3', [(_vm.filterExtension(doc.file_name)) ? _c('el-row', {
      staticStyle: {
        "position": "absolute",
        "top": "30%",
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('i', {
      class: ['fa', _vm.filterExtension(doc.file_name), 'fa-5x']
    }), _c('br'), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getAsset(doc.file_name)
      }
    }, [_c('i', {
      staticClass: "fa fa-cloud-download"
    }), _vm._v(" " + _vm._s(_vm.$t('DOWNLOADFILE')))])]) : _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.getAsset(doc.file_name)
      }
    }), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      },
      domProps: {
        "textContent": _vm._s(doc.label || _vm.$t('NOLABEL'))
      }
    })], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e0daeca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Doc.vue
// module id = 618
// module chunks = 1